import { convertUTCtoUserLocalTimeZone, getUserGMT } from '../../../utils/utils';
import * as moment from 'moment-timezone';

const convertFileUpload = response => {
  return response.map(item => ({
    ...item,
    upload_datetime: convertUTCtoUserLocalTimeZone(
      item?.upload_datetime,
      item?.timezone ? item.timezone : getUserGMT(),
      moment.tz.guess()
    ),
  }));
};

export { convertFileUpload };
